<!-- 发布通知 -- 新增 -->
<template>
  <basic-container>
    <div class="width-p100 ds-fx flex-direction-row">
      <el-form :model="form" :rules="rules" ref="form">
        <el-row>
          <el-form-item
            label="专项检查名称"
            prop="TITLE"
            :rules="[
              {
                required: true,
                message: '请输入专项检查名称',
              },
            ]"
            label-width="120px"
          >
            <el-input size='mini' v-model="form.TITLE" :disabled="$route.query.ID"></el-input>
          </el-form-item>
        </el-row>
        <el-row style="position: relative;">
          <div v-if="$route.query.pageType == '3'" style="position: absolute; left: 0; top: 0; bottom: 0; right: 0; z-index: 9999;"></div>
          <el-form-item label="专项检查描述" prop="REMARK" label-width="120px">
            <avue-ueditor v-model="form.REMARK" :options="option" :readOnly="true"></avue-ueditor>
          </el-form-item>
        </el-row>
        <el-row v-if="!$route.query.ID">
          <el-form-item
            label="选择附件"
            prop="KSSJ"
            label-width="120px"
          >
            <el-upload
              class="upload-demo"
              ref="upload"
              action=""
              :on-change="
                (file, fileList) => {
                  onChange(file, fileList);
                }
              "
              :on-remove="
                (file, fileList) => {
                  handleRemove(file, fileList);
                }
              "
              :file-list="fileList"
              :auto-upload="false"
              multiple
            >
              <el-button size="mini" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-row>
        <el-row v-else-if="fileDataList.length > 0">
          附件列表
          <table border="1" style="width:100%">
            <tr>
              <td style="text-align:center">附件名称</td>
              <td style="text-align:center">操作</td>
            </tr>
            <tr v-for="item,index in fileDataList" :key="index">
              <td style="text-align:center">{{ item.SHOW_NAME }}</td>
              <td style="text-align:center"> <el-button size="mini" type="text" @click="downloadFile(item)">下载</el-button> </td>
            </tr>
          </table>
        </el-row>
        <el-row class="mt-xxs ds-fx flex-direction-row justify-content-center">
          <el-button :loading="btnLoading" type="warning" size="mini" class="mr-xs" icon="el-icon-check" @click="save" v-if="!$route.query.ID">确定</el-button>
          <el-button :loading="btnLoading" type="primary" size="mini" class="mr-xs" icon="el-icon-back" @click="cancle">取消</el-button>
        </el-row>
      </el-form>
    </div>
  </basic-container>
</template>

<script>
import { addShow, getShow, download } from "@/api/table/table";
import { usualUploadFile, usualGetFileList } from "@/api/system/file";
export default {
  components: {},
  data() {
    return {
      fileList:[],
      form: {}, //表单
      option: {
        props: {
          res: "data",
          url: "url",
        },
        customConfig: {
          menus: [
            "head", // 标题
            "bold", // 粗体
            "fontSize", // 字号
            "fontName", // 字体
            "italic", // 斜体
            "underline", // 下划线
            "strikeThrough", // 删除线
            "foreColor", // 文字颜色
            "backColor", // 背景颜色
            "link", // 插入链接
            "list", // 列表
            "justify", // 对齐方式
            "quote", // 引用
            // "emoticon", // 表情
            "image", // 插入图片
            "table", // 表格
            "video", // 插入视频
            "code", // 插入代码
            "undo", // 撤销
            "redo", // 重复
          ],
        }, //wangEditor编辑的配置
      },
      btnLoading: false,
      fileDataList:[]
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //方法集合
  methods: {
    // 附件改变
    onChange(file,fileList){
      this.fileList = fileList;
    },
    // 附件删除
    handleRemove(file,fileList){
      this.fileList = fileList;
    },
    // 点击保存
    async save(){
      this.$refs.form.validate(async valid=>{
        if(valid){
          try{
            this.btnLoading = true;
            let res = await addShow({
              opid:3767,
              dataClass:1,
              data:this.form,
              runId:this.$route.query.runId
            })
            if(this.fileList.length){
              this.uploadFiles(res.data.data);
            }
            this.$message.success("操作成功");
            this.cancle();
            this.fileList = [];
            this.btnLoading = false;
          } catch(e){
            this.btnLoading = false;
          }
        }else{
          return false
        }
      })
    },
    // 点击取消
    cancle(){
      this.$store.commit("DEL_TAG", { value: this.$route.fullPath });
      this.$router.go(-1);
    },
    // 上传附件
    uploadFiles(ID){
      let newArr = [];
      let fileData = new FormData();
      this.fileList.forEach((file,index)=>{
        fileData.append("files",file.raw);
        newArr.push({
          SHOW_NAME: file.name
        })
      })
      fileData.append("runId", this.$route.query.runId);
      fileData.append("businessId", ID);
      fileData.append("businessType", "505");
      fileData.append("newProps", JSON.stringify(newArr));
      usualUploadFile(fileData).then( res => {});
    },
    // 查看进来获取数据
    getData(){
      getShow(1,10,this.$route.query.runId,{
        obj: { ID: this.$route.query.ID },
        opid: 3767
      }).then(data => {
        for (const key in data.data.data.records[0]) {
          const element = data.data.data.records[0][key];
          this.$set(this.form,key,element);
        }
        this.getFileList();
      },error => {})
    },
    // 获取附件信息
    getFileList(){
      usualGetFileList({
        runId: this.$route.query.runId,
        businessId: this.$route.query.ID,
        businessType: 505
      }).then(rus => {
        this.fileDataList = rus.data.data.records;
      },error => {})
    },
    // 点击附件下载
    downloadFile(item){
      download({
        filePath: 'xfjd/' + item.SAVE_NAME,
        fileName: item.SHOW_NAME + '.' + item.SUFFIX
      }).then(res => {
        this.downloadFun(res,item.SHOW_NAME + '.' + item.SUFFIX);
      }).catch((err) => { console.log(err) })
    },
    // 附件下载方法
    downloadFun(res, name) {
      const blob = new Blob([res.data], {
        type: 'application/octet-stream'
      })
      let url = window.URL.createObjectURL(blob);//为文件流创建构建下载链接
      let link = document.createElement('a');//创建a标签
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', name);//设置a标签的下载动作和下载文件名
      document.body.appendChild(link);
      link.click();//执行下载
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);//释放标签
    },
  },
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  activated() {
    if(this.$route.query.ID){
      this.getData();
    }else{
      this.form = {};
      this.fileDataList = [];
    }
  }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss'scope>
.echartBox {
  width: 100% !important;
  height: 300px;
}
.font_family {
  font-family: inherit !important;
}
/deep/.el-upload-list__item{
  margin-bottom: 2px !important;
  line-height: 1.5 !important;
}
</style>
